module.exports = __webpack_public_path__ + "img/header.f378648a.png";